<script setup lang="ts">
import { customElementPropsKey } from '@/types/customElementProps.types'
import { computed, inject } from 'vue'

const templateProps = inject(customElementPropsKey)
const type = computed(() => templateProps?.genericMessageType)
const message = computed(() => templateProps?.genericMessage)
</script>

<template>
  <v-alert v-if="message" :type="type" class="mt-6 text-body-2">
    <span class="font-weight-bold">{{
      $t(`generic-message.type.${type}`)
    }}</span>
    <span>{{ message }}</span>
  </v-alert>
</template>
